import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import HorizontalFormBlockWrapper from '../../../components/forms/HorizontalFormBlockWrapper';
import { Checkbox, Table, Text } from "rizzui";
import FormFooter from '../../_layout/_footers/form-footer';
import { useSettingsProvider } from '../provider/SettingsProvider';

// Modelo 2024/25 (placeholder)
const DAILY_2024 = [
  { label: "1 punto/día", value: "0,00 €" },
  { label: "2 puntos/día", value: "20,00 €" },
  { label: "3 puntos/día", value: "30,00 €" },
  { label: "4 puntos/día", value: "40,00 €" },
  { label: "Sucesivos/día", value: "50,00 €" },
];

const WEEKLY_2024 = [
  { label: "<= 4 puntos", value: "0,00 €" },
  { label: "5 puntos", value: "50,00 €" },
  { label: "6 puntos", value: "75,00 €" },
  { label: "7 puntos", value: "90,00 €" },
  { label: "8 puntos", value: "100,00 €" },
  { label: "9 puntos", value: "120,00 €" },
  { label: "10 puntos", value: "150,00 €" },
  { label: "> 11 puntos", value: "180,00 €" },
];

const MONTHLY_2024 = [
  { range: "12 pts (30h) / 11 pts (25h)", value: "75,00 €" },
  { range: "13 pts (30h) / 12 pts (25h)", value: "150,00 €" },
  { range: "14 pts (30h) / 13 pts (25h)", value: "225,00 €" },
  { range: "15 pts (30h) / 14 pts (25h)", value: "300,00 €" },
  { range: "16 pts (30h) / 15 pts (25h)", value: "375,00 €" },
  { range: "17 pts (30h) / 16 pts (25h)", value: "450,00 €" },
  { range: "18 pts (30h) / 17 pts (25h)", value: "525,00 €" },
  { range: "19 pts (30h) / 18 pts (25h)", value: "600,00 €" },
  { range: "20 pts (30h) / 19 pts (25h)", value: "675,00 €" },
  { range: "21 pts (30h) / 20 pts (25h)", value: "750,00 €" },
  { range: "22 pts (30h) / 21 pts (25h)", value: "900,00 €" },
  { range: "23 pts (30h) / 22 pts (25h)", value: "1050,00 €" },
  { range: "24 pts (30h) / 23 pts (25h)", value: "1200,00 €" },
  { range: "25 pts (30h) / 24 pts (25h)", value: "1350,00 €" },
  { range: "> 25 pts (30h) / > 24 pts (25h)", value: "1500,00 €" },
];


// MODELO REAL 2026
const COMMISSIONS_2026 = [
  { points: 10, impVenta: 30, total: 30, pago1: 30, pago2: 0 },
  { points: 11, impVenta: 30, total: 30, pago1: 30, pago2: 0 },
  { points: 12, impVenta: 75, total: 75, pago1: 75, pago2: 0 },
  { points: 13, impVenta: 25, total: 100, pago1: 75, pago2: 25 },
  { points: 14, impVenta: 30, total: 130, pago1: 75, pago2: 55 },
  { points: 15, impVenta: 35, total: 165, pago1: 90, pago2: 75 },
  { points: 16, impVenta: 40, total: 205, pago1: 110, pago2: 95 },
  { points: 17, impVenta: 45, total: 250, pago1: 125, pago2: 125 },
  { points: 18, impVenta: 50, total: 300, pago1: 150, pago2: 150 },
  { points: 19, impVenta: 50, total: 350, pago1: 175, pago2: 175 },
  { points: 20, impVenta: 50, total: 400, pago1: 200, pago2: 200 },
  { points: 21, impVenta: 50, total: 450, pago1: 225, pago2: 225 },
  { points: 22, impVenta: 50, total: 500, pago1: 250, pago2: 250 },
  { points: 23, impVenta: 50, total: 550, pago1: 275, pago2: 275 },
  { points: 24, impVenta: 50, total: 600, pago1: 300, pago2: 300 },
  { points: 25, impVenta: 100, total: 700, pago1: 350, pago2: 350 },
  { points: 26, impVenta: 50, total: 750, pago1: 375, pago2: 375 },
  { points: 27, impVenta: 50, total: 800, pago1: 400, pago2: 400 },
  { points: 28, impVenta: 50, total: 850, pago1: 425, pago2: 425 },
  { points: 29, impVenta: 50, total: 900, pago1: 450, pago2: 450 },
  { points: 30, impVenta: 100, total: 1000, pago1: 500, pago2: 500 }
];

const pageHeader = {
    title: 'Ajustes del Modelo de Comisiones',
    breadcrumb: [
        { name: 'Inicio', href: menuRoutes.dashboard.path },
        { name: 'Configuración' },
        { name: 'Comisiones', href: menuRoutes.settings.path + menuRoutes.settings.commissions },
    ]
};

const CommissionSettingsPage: React.FC = () => {

  const {
    formik,
    isLoading,
    companyConfig,
    updateCompanyConfig,
    hasCompanyConfigChanges,
    discardCompanyConfigChanges,
    setShowModal
  } = useSettingsProvider();

  const selectedModel = formik.values.activeContractCommissionModel;

  const handleModelChange = (value: string) => {
    updateCompanyConfig("activeContractCommissionModel", value);
    formik.setFieldValue("activeContractCommissionModel", value);
  };

  return (
    <div className="h-full overflow-auto scrollbar">
      <PageHeader
        title={pageHeader.title}
        breadcrumb={pageHeader.breadcrumb}
        className="border-b-4 border-dotted border-grey-500 top-0"
      />

      <HorizontalFormBlockWrapper
        title="Modelo de Comisiones"
        description="Selecciona qué modelo de comisiones utilizará la empresa."
        childrenWrapperClassName="@md:col-span-10 md:grid-cols-2"
      >

        {/* Checkbox 2024/25 */}
        <div className="flex items-center space-x-3 pb-4">
          <Checkbox
            checked={selectedModel === "2024/25"}
            onChange={() => handleModelChange("2024/25")}
          />
          <Text className="font-medium">Modelo 2024/25</Text>
        </div>

        {/* Checkbox 2026 */}
        <div className="flex items-center space-x-3 pb-4">
          <Checkbox
            checked={selectedModel === "2026"}
            onChange={() => handleModelChange("2026")}
          />
          <Text className="font-medium">Modelo 2026</Text>
        </div>

        {/* Vista previa dinámica */}
        <div className="col-span-full mt-6">

          {selectedModel === "2026" && (
            <Model2026Preview />
          )}

          {selectedModel === "2024/25" && (
            <Model2024Preview />
          )}

        </div>

      </HorizontalFormBlockWrapper>

      {(hasCompanyConfigChanges ||
        companyConfig?.activeContractCommissionModel !== formik.values.activeContractCommissionModel) && (
        <FormFooter
          customClassName="w-full"
          submitBtnText="Aplicar cambios"
          cancelBtnText="Descartar cambios"
          handleCancelBtn={() => discardCompanyConfigChanges()}
          handleSubmitBtn={() => setShowModal(true)}
          isLoading={isLoading}
          isDisabled={Object.keys(formik.errors).length > 0}
        />
      )}
    </div>
  );
};

// ---------------- COMPONENTE MODELO 2026 ----------------

const Model2026Preview = () => (
  <div className="border rounded-lg bg-white shadow p-4">
    <Text className="font-semibold text-lg mb-4">Tabla modelo 2026:</Text>

    <Table>
      <thead>
        <tr className="text-left border-b">
          <th className="py-2">Puntos</th>
          <th className="py-2">IMP/VENTA</th>
          <th className="py-2">Pago 1</th>
          <th className="py-2">Pago 2</th>
          <th className="py-2">Total (€)</th>
        </tr>
      </thead>

      <tbody>
        {COMMISSIONS_2026.map((row, idx) => (
          <tr key={idx} className="border-b last:border-none">
            <td className="py-2">{row.points}</td>
            <td className="py-2">{row.impVenta}</td>
            <td className="py-2">{row.pago1}</td>
            <td className="py-2">{row.pago2}</td>
            <td className="py-2 font-semibold">{row.total} €</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </div>
);

// ---------------- COMPONENTE MODELO 2024 ----------------

const Model2024Preview = () => (
  <div className="space-y-10">

    {/* INCENTIVO DIARIO */}
    <div className="border rounded-lg bg-white shadow p-4">
      <Text className="font-semibold text-lg mb-4">Incentivo diario</Text>

      <Table>
        <tbody>
          {DAILY_2024.map((row, idx) => (
            <tr key={idx} className="border-b last:border-none">
              <td className="py-2 font-medium">{row.label}</td>
              <td className="py-2 text-right">{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <p className="text-xs text-gray-500 mt-3 italic">
        * Si el valor diario termina en 0.5, se incrementan 10 € adicionales en el total.
      </p>
    </div>

    {/* INCENTIVO SEMANAL */}
    <div className="border rounded-lg bg-white shadow p-4">
      <Text className="font-semibold text-lg mb-4">Incentivo semanal</Text>

      <Table>
        <tbody>
          {WEEKLY_2024.map((row, idx) => (
            <tr key={idx} className="border-b last:border-none">
              <td className="py-2 font-medium">{row.label}</td>
              <td className="py-2 text-right">{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>

    {/* INCENTIVO MENSUAL */}
    <div className="border rounded-lg bg-white shadow p-4">
      <Text className="font-semibold text-lg mb-4">Incentivo mensual</Text>

      <Table>
        <thead>
          <tr className="text-left border-b">
            <th className="py-2">Rango Puntos (30h / 25h)</th>
            <th className="py-2 text-right">Valor (€)</th>
          </tr>
        </thead>

        <tbody>
          {MONTHLY_2024.map((row, idx) => (
            <tr key={idx} className="border-b last:border-none">
              <td className="py-2">{row.range}</td>
              <td className="py-2 text-right font-semibold">{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>

  </div>
);

export default CommissionSettingsPage;